class FaqCollection extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelectorAll('details');
    this.mainDetailsToggle.forEach((toggle) => {
      toggle.addEventListener('click', this.toggleMainDetails.bind(this));
    });
  }

  toggleMainDetails(event) {
    this.mainDetailsToggle.forEach((toggle) => {
      if (toggle !== event.target.closest('details')) {
        toggle.removeAttribute('open');
      }
    });
  }
}

customElements.define('faq-collection', FaqCollection);
